module.exports = __webpack_public_path__ + "files/116b56d1fe05ade372bb4fac744886b8.png";